import { render, staticRenderFns } from "./WhatsappWebApi.vue?vue&type=template&id=1a71847c&"
import script from "./WhatsappWebApi.vue?vue&type=script&lang=js&"
export * from "./WhatsappWebApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports